import * as ng from 'angular';

export interface GuestType {
   id: number;
   campaignId: number;
   name: string;
   slug: string;
   settings: {
      color: string
   }
}

export class GuestTypeService {
   static $inject = ['apiHelper'];

   constructor(
      private apiHelper,
   ) { }

   list(campaignId:number):ng.IPromise<GuestType[]> {
      return this.apiHelper.get(`guestTypes?campaignId=${campaignId}`);
   }

   get(guestTypeId:number):ng.IPromise<GuestType> {
      return this.apiHelper.get('guestTypes/' + guestTypeId);
   }

   create(guestType:GuestType):ng.IPromise<GuestType> {
      return this.apiHelper.post('guestTypes', guestType);
   }

   update(guestType:GuestType):ng.IPromise<GuestType> {
      return this.apiHelper.post(`guestTypes/${guestType.id}`, guestType);
   }

   delete(id:number, force:boolean) {
      // ensure `force` is a boolean value
      force = force !== true ? false : true;

      let url = `guestTypes/${id}?force=${force}`;
      return this.apiHelper.del(url);
   }
}

ng.module('e360')
   .service('GuestTypeService', GuestTypeService);
